import useRouteTracker from './use-route-tracker';

function Tracker() {
  useRouteTracker();
  return null;
}

export default Tracker;
